import axios from "axios";
import BASE_URL from "../../assets/global/url";

// Soft-deletes a Pending Profit Distribution and frees its Retained Net Incomes
export const deleteProfitDistribution = async (payload) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/profit_distribution/deleteProfitDistribution`,
      payload,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
